import type { MetaAdsTranslations } from '../interfaces/metaAds';

export const metaAdsTranslations: MetaAdsTranslations = {
  page_title: 'Meta Ads',
  page_subtitle:
    'Conecta tu cuenta publicitaria de Meta y sigue el rendimiento de tus campañas.',
  manage_connection: 'Gestionar conexión',

  connect_title: 'Conectar Meta Ads',
  connect_body:
    'Inicia sesión con Facebook para vincular una cuenta publicitaria y ver aquí los datos de tus campañas.',
  connect_button: 'Conectar con Facebook',
  sdk_error:
    'No se pudo cargar el SDK de Facebook. Desactiva tu bloqueador de anuncios en esta página y recarga.',
  config_missing:
    'El login de Meta Ads todavía no está configurado para este ambiente.',
  toast_connected: 'Cuenta de Facebook conectada',
  toast_cancelled: 'Inicio de sesión cancelado',
  toast_error: 'Algo salió mal. Intenta de nuevo.',

  pick_account_title: 'Elige una cuenta publicitaria',
  pick_account_body:
    'Tu login de Facebook está conectado. Elige la cuenta publicitaria que quieres seguir.',
  reload_accounts: 'Recargar cuentas',
  available_empty:
    'No hay cuentas publicitarias visibles con este login de Facebook.',
  account_connect: 'Conectar',
  account_connected: 'Conectada',
  account_not_covered: 'Sin acceso',
  toast_account_connected: 'Cuenta publicitaria conectada',

  account_select_label: 'Cuenta publicitaria',
  range_label: 'Rango de fechas',
  range_today: 'Hoy',
  range_7d: 'Últimos 7 días',
  range_14d: 'Últimos 14 días',
  range_30d: 'Últimos 30 días',
  sync_button: 'Sincronizar ahora',
  toast_sync_started:
    'Sincronización iniciada — los datos se actualizarán en un momento',
  refresh_button: 'Actualizar',

  summary_spend: 'Inversión',
  summary_impressions: 'Impresiones',
  summary_clicks: 'Clics',
  summary_ctr: 'CTR',
  summary_cpc: 'CPC',
  summary_conversations: 'Conversaciones',
  settling_note:
    'Parte de los datos recientes aún se están consolidando en Meta y pueden cambiar levemente.',

  campaigns_title: 'Campañas',
  campaigns_empty_title: 'Aún no hay datos de campañas',
  campaigns_empty_body:
    'Ejecuta una sincronización para traer las campañas y métricas de Meta para el rango seleccionado.',
  table_campaign: 'Campaña',
  table_status: 'Estado',
  table_spend: 'Inversión',
  table_impressions: 'Impresiones',
  table_clicks: 'Clics',
  table_conversations: 'Conversaciones',
  table_cost_per_conversation: 'Costo / conv.',
  status_active: 'Activa',
  status_paused: 'Pausada',
};
